const providers = {
  nemo: 'https://app.nemoexpress.ro/nemo/Main?tracking=true&appcont=500&awbno=',
  nemoexpress: 'https://app.nemoexpress.ro/nemo/Main?tracking=true&appcont=500&awbno=',
  same: 'https://sameday.ro/#awb=',
  sameday: 'https://sameday.ro/#awb=',
  fan: 'https://www.fancourier.ro/en/awb-tracking/?awb=',
  fancourier: 'https://www.fancourier.ro/en/awb-tracking/?awb=',
  cargus: 'https://www.cargus.ro/personal/urmareste-coletul/?tracking_number=',
  urgent: 'https://www.cargus.ro/personal/urmareste-coletul/?tracking_number=',
  urgentcargus: 'https://www.cargus.ro/personal/urmareste-coletul/?tracking_number=',
  dpd: 'https://tracking.dpd.ro/?shipmentNumber=',
  gls: 'https://gls-group.com/RO/ro/urmarire-colet/?match=',
  bookurier: 'https://bookurier.ro/colete/AWB/trackifnew.php?awb=',
};

/**
 * Compose path for awb
 * @param {string|number} awb
 * @param {string} courier
 * @returns {string}
 */
export default function getAwbPath(awb, courier) {
  const provider = providers[courier.toLowerCase()];
  if (provider) {
    return `${ provider }${ awb }`;
  }
  return '';
}
